import Controller from './controller'

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 5000 }
  }

  connect() {
    this.timeout = setTimeout(() => {
      this.openTimedModal()
    }, this.delayValue)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  openTimedModal() {
    const modalId = 'timed-modal';
    if (window.Stimulus && window.Stimulus.getControllerForElementAndIdentifier) {
      const modal = window.Stimulus.getControllerForElementAndIdentifier(document.querySelector('[data-modal-id="' + modalId + '"]'), 'modal');
      if (modal && typeof modal.open === 'function') {
        modal.open();
        return;
      }
    }
    const template = document.querySelector('template[data-modal-id="' + modalId + '"]');
    if (template) {
      const modalEl = document.importNode(template.content, true).firstElementChild;
      modalEl.dataset.modalId = modalId;
      modalEl.id = 'modal-' + modalId;
      document.body.appendChild(modalEl);
    }
  }
}
